import { useEffect, useRef } from 'react';

const konamiCode = [
  'ArrowUp',
  'ArrowUp',
  'ArrowDown',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'ArrowLeft',
  'ArrowRight',
  'b',
  'a'
];

/**
 * Hook for detecting Konami Code (↑↑↓↓←→←→BA)
 * @param callback Function to call when Konami code is entered
 */
export const useKonamiCode = (callback: () => void) => {
  const keysRef = useRef<string[]>([]);
  const callbackRef = useRef(callback);

  // Update ref when callback changes
  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Add the key to our sequence, keep only last 10
      keysRef.current = [...keysRef.current, e.key].slice(-10);

      // Check if sequence matches Konami code
      if (keysRef.current.join(',') === konamiCode.join(',')) {
        callbackRef.current();
        keysRef.current = []; // Reset
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []); // Empty dependency array - only set up once
};
